export default () => (
  <svg
    width="12"
    data-testid="plus-key-combo"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8334 6.83268H6.83341V11.8327H5.16675V6.83268H0.166748V5.16602H5.16675V0.166016H6.83341V5.16602H11.8334V6.83268Z"
      fill="white"
    />
  </svg>
);
